import { __assign, __rest } from "tslib";
// DS2.5.2
import React from 'react';
import c from 'classnames';
import { ThemeOverride, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import IconButton from '..';
import s from './IconButtonWithBackground.scss';
var IconButtonWithBackground = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement("div", { className: c(s['root'], className) },
        React.createElement(ThemeOverride, { theme: ThemeOptions.DARK },
            React.createElement(IconButton, __assign({ variant: "main" }, props)))));
};
IconButtonWithBackground.displayName = 'IconButtonWithBackground';
export default IconButtonWithBackground;
//# sourceMappingURL=IconButtonWithBackground.js.map